import { useState, useEffect } from 'react';
import axios from 'axios';
import { environment } from '../../../../environment/environment';
import toast from '../../../../utils/toast';

interface UpdatedField {
  name: string;
  old_value: any;
  new_value: any;
}

export interface AuditTrailEntry {
  actioned_by_name: string;
  date: string;
  action: string;
  updated_fields: UpdatedField[];
}

export const useBlacklistedMobileNumberAuditTrail = (mobileNumber: string | null) => {
  const [data, setData] = useState<AuditTrailEntry[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!mobileNumber) {
      setData([]);
      return;
    }

    const fetchAuditTrail = async () => {
      setLoading(true);

      try {
        const response = await axios.post<AuditTrailEntry[]>(
          `${environment.baseUrl}/blacklisted-mobile-numbers/audit-trail/`,
          { mobile_number: mobileNumber }
        );
        setData(response.data);
      } catch (err: any) {
        if (err.response?.status === 404) {
          setData([]);
        } else {
          toast.error('Failed to fetch audit trail');
          setData([]);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchAuditTrail();
  }, [mobileNumber]);

  return { data, loading };
};